module.exports = __webpack_public_path__ + "6492a1e2d44998c20b1b6a5ed5e583b7.svg";